import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { PublicRoutes } from './PublicRoutes';
import { SuperAdminRoutes, AdminRoutes, ManagerRoutes, UserRoutes } from './ProtectedRoutes';
const PublicLayouts = lazy(() => import('Layouts/PublicLayouts'));
const ProtectedLayouts = lazy(() => import('Layouts/Protected/ProtectedLayouts'));
const PageNotFound = lazy(() => import('Pages/Errors/PageNotFound'));
const Clients = lazy(() => import('Pages/Clients'));
const ViewClient = lazy(() => import('Pages/ViewClient'));

const AllRoutes = () => (
  <React.Fragment>
    <Routes>
      <Route
        element={
          <Suspense>
            <PublicLayouts />
          </Suspense>
        }
      >
        <Route exact path="/">
          {PublicRoutes.map((item) => (
            <Route key={item.path} path={item.path} element={item.element} />
          ))}
        </Route>
      </Route>
      <Route
        element={
          <Suspense>
            <ProtectedLayouts />
          </Suspense>
        }
      >
        <Route exact path="/super-admin">
          {SuperAdminRoutes.map((item) => (
            <Route key={item.path} path={item.path} element={item.element} />
          ))}
        </Route>
        <Route exact path="/admin">
          {AdminRoutes.map((item) => (
            <Route key={item.path} path={item.path} element={item.element} />
          ))}
        </Route>
        <Route exact path="/manager">
          {ManagerRoutes.map((item) => (
            <Route key={item.path} path={item.path} element={item.element} />
          ))}
        </Route>
        <Route exact path="/user">
          {UserRoutes.map((item) => (
            <Route key={item.path} path={item.path} element={item.element} />
          ))}
        </Route>
        <Route exact path="/clients" element={<Suspense><Clients /></Suspense>} />
        <Route exact path="/view-client/:id" element={<Suspense><ViewClient /></Suspense>} />
      </Route>
      <Route
        path="*"
        element={
          <Suspense>
            <PageNotFound />
          </Suspense>
        }
      />
    </Routes>
  </React.Fragment>
);

export default AllRoutes;
